module.exports = __webpack_public_path__ + "img/1601.e95e1178.png";